<form (ngSubmit)="onSubmit()" #organisationForm="ngForm" ngForm="organisationForm">
  <div class="form-group">
    <div class="container container-shadow">
      <div class="form-group  font-color-navy">
        <div class="panel panel-default">
          <div class="panel panel-body container-shadow">
            <div class="row">
              <input type="hidden" name="Organization" />
              <div class="col-md-3">
                <b><label class="form-label">Azure DevOps Server Organization:</label></b>
                <select class="form-control control-bg" name="organisation" ngModel>
                  <option *ngFor="let org of organisations" [value]="org.name">{{org.name}}</option>
                </select>
              </div>
              <div class="col-md-8 offset-1">
                <ul>
                  <li>
                    This module enables you to connect to your azure DevOps Server Organization.
                  </li>
                  <li>
                    Please select your Azure DevOps server organization from the dropdown where you want to review.
                  </li>
                  <li>
                    The selection will be saved in a session and the user will be redirected back to this page once the session expires.
                  </li>
                </ul>
              </div>
              <br />
              <div class="clearfix"></div>
            </div>
            <br />
            <div class="row">
              <div class="d-flexd-flex justify-content-end text-end">
                <input type="submit" id="btnOrganizationSubmit" value="Connect" class="btn-new-ui pull-right" data-disabled-onsubmit="true" />
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <br />
    </div>
  </div>
</form>
